/* eslint-disable no-unused-vars */
import { useCallback } from 'react';
import { useIntl } from 'react-intl';
import { Box } from '@mui/material';

import AgButton from '../../stories/Components/AgButton';
import AgTextField from '../../stories/Components/AgTextField';

const AgPin = ({ value, setPin }: { value: string; setPin: (value: string) => void }) => {
  const messages = useIntl().formatMessage;
  const digits = 4;

  const onGeneratePin = useCallback(() => {
    let pin = '';
    for (let i = 0; i < digits; i++) {
      pin += Math.floor(Math.random() * 10);
    }
    setPin(pin);
  }, [setPin]);

  return (
    <Box sx={{ width: '48%' }}>
      <AgTextField
        label={messages({ id: 'PIN' })}
        disabled
        value={value}
        buttonRight={(
          <AgButton 
            label={messages({ id: 'GENERATE_PIN' })}
            style={{ borderRadius: '0 5px 5px 0' }}
            onClick={onGeneratePin}
            disabled={!!value}
          />
        )}
      />
    </Box>
  );
};

export default AgPin;